import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, RadioGroup, NavigationButtons, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const AskPreviousCitizenshipStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [title, setTitle] = useState('Har du tidligere været statsborger i et andet land?');
  const [body, setBody] = useState<string[]>([]);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.ask_previous_citizenship).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body) {setBody(c.body);}
    });
  }, []);

  const handleChange = (value: string) => {
    updateSelfServiceData('previousCitizenship', value === 'yes');
  };

  const handleNext = () => {
    if (selfServiceData.previousCitizenship !== undefined) {
      goNext();
    }
  };

  const options = [
    { value: 'yes', label: 'Ja' },
    { value: 'no', label: 'Nej' },
  ];

  return (
    <StepContainer title={title}>
      {body.length > 0 && (
        <InfoBox type="info">
          {body.map((p, i) => <p key={i}>{p}</p>)}
        </InfoBox>
      )}
      <RadioGroup
        name="previousCitizenship"
        options={options}
        value={selfServiceData.previousCitizenship === undefined ? '' : (selfServiceData.previousCitizenship ? 'yes' : 'no')}
        onChange={handleChange}
        legend={title}
        required={true}
      />
      <NavigationButtons
        onBack={goBack}
        onNext={handleNext}
        nextDisabled={selfServiceData.previousCitizenship === undefined}
      />
    </StepContainer>
  );
};

export default AskPreviousCitizenshipStep;



